// Angular import
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatDrawer, MatDrawerMode } from '@angular/material/sidenav';

// Project import
import { AbleProConfig } from 'src/app/app-config';
import { menus } from 'src/app/demo/data/hotelMenu';
import { LayoutService } from 'src/app/@theme/services/layout.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { RequestService } from '../../../services/http-service.service'

@Component({
  selector: 'app-hotel',
  templateUrl: './hotel.component.html',
  styleUrls: ['./hotel.component.scss']
})
export class HotelComponent implements OnInit, AfterViewInit {
  // public props
  @ViewChild('sidebar') sidebar: MatDrawer;
  ableProConfig;
  menus = menus;
  modeValue: MatDrawerMode = 'side';
  direction: string;
  currentApplicationVersion = environment.appVersion;

  // Constructor
  constructor(
    private breakpointObserver: BreakpointObserver,
    private layoutService: LayoutService,
    public router:Router,
    public request:RequestService
  ) {
    this.ableProConfig = AbleProConfig;
  }

  // life cycle event
  ngOnInit() {
    this.breakpointObserver.observe(['(min-width: 1025px)', '(max-width: 1024.98px)']).subscribe((result) => {
      if (result.breakpoints['(max-width: 1024.98px)']) {
        this.modeValue = 'over';
      } else if (result.breakpoints['(min-width: 1025px)']) {
        this.modeValue = 'side';
      }
    });

    this.layoutService.layoutState.subscribe(() => {
      this.sidebar.toggle();
    });
  }

  ngAfterViewInit() {
    this.layoutService.directionChange.subscribe((direction: string) => {
      this.direction = direction;
    });
  }
}
